export class OptimizationStatus {
  RouteId: string;
  Mode: string;
  ModeDescription: string;
  StartTime: string;
  EndTime: string;
  Status: string;
  RouteStatus: string;
  EnableMoveStop: boolean;
  AllowReoptimization: boolean;
}
